import React from 'react';

export default function ProviderVerificationStepPage() {
  return (
    <div>
      <h2>Verification</h2>
      <p>
        Upload and review provider verification documents before the business can go live.
      </p>
    </div>
  );
}